import React, {useState, useEffect } from 'react'
import { connect } from 'react-redux'
import * as cartActions from './../../../action/cart'
import * as buildProductAction from './../../../action/buildProduct';
import * as buildfiosaction from './../../../action/buildProduct';
import FirstBill from './../../firstBill';
import { tempVzdlSCData, updateVzdlSCCustomEvent } from './../../../service/vzdl';
import { updateSCTags } from './../../../service/dtmTag';
import ReactHtmlParser from 'react-html-parser';
import { ModalBody } from '@vds/modals';
import PromoDisclaimer from './../../../constants/promoDisclaimer';
import * as modalAction from './../../../action/modalWindow';
import {  LocationIds, OfferTypes} from './../../../constants/actionType';
import { InHomeUtils } from './../../../util/inhomeUtils';
import { Body, Micro } from '@vds/typography';
import { TitleLockup } from '@vds/type-lockups';
import {getPerkActualPrice } from './../../midnight/services/dataFormatter';
import ContentRenderComp from './ContentRenderComp';
import { orderConstants } from './../../orderSummary/orderSummaryConstants';

const OrderSummaryReskin = (props) => {
  const { lqState, appState, cartRedState,cartProfileState, modalWindowState, checkoutState, buildProductState, visitId, dispatch, showMovesOldCart, cust_optState, moveExpState } = props;
  
  const cartState = showMovesOldCart ? cartRedState: cartProfileState;
  let movesEligibility = "";
  if(InHomeUtils.isNotEmpty(moveExpState) && InHomeUtils.isNotEmpty(moveExpState.movesEligibility)){
    movesEligibility = moveExpState?.movesEligibility==="NONSEAMLESS" ? 'NONSEAMLESS' :'SEAMLESS';     
  }

  const [activeTabIndex, setactiveTabIndex] = useState(cartState.splitBillTab);
  let isCartDataEmpty = cartState.cartData !== null && cartState.cartData.length !== 0 ? true : false;
  
  const [ isClassicalFlow ] = useState(movesEligibility === "SEAMLESS" ? !buildProductState.internet.mm3Qualified:!buildProductState.mnFromApi);  
  const isMobile = (window.screen.width < 768) ? true : false; 
  let OneTimePrice = "0";
  let setupcharge = cartState.isFiosSetupFee;
  let isSetupFeeWaived = false;
  let splitBillTab = activeTabIndex;
  let mnFiosDiscount = '';
  let professionalCharge = '';
  const [promoContentLayout, setpromoContentLayout] = useState('');
  let qualifiedSpeedProducts = buildProductState.internet.m2mPlans;
  let maxSpeedCode = buildProductAction.getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
  let specialOffer = '';
  let secTotalPrice = '';
  let disclaimerStreaming;
  let disclaimerTechSure;
  let disclaimerStreamingSling;
  let isYoutube = false;
  let isYoutubeAbove = false;
  let isYoutubeBelow = false;
  let isSlingTV = false;
  let isSlingTVAbove = false;
  let isSlingTVBelow = false;
  let isTechSure = false;
  let isTechSureAbove = false;
  let isTechSureBelow = false;
  let perksInSavings='';
  let onetimefee = false;
  let isOnetimefee=false;
  let onetimecharge = "";
  let monthlyCharge = "";
  let isSplOfferAvailable = false;
  let isMonthlyCharge = false;
  const product = buildProductState.internet.selectedProduct ||  cartState?.cartData[0]?.serviceHeaders?.servicehead?.find(item=>item?.prodType==='FTTPD');
  const list = [...(product?.specialOffers || []), ...(product?.discountOffers || [])];
  let fiosPresent = list.find(item => item.OfferText.toLowerCase().includes('fios setup discount'));
  //const fiosPresentDiscountApply = fiosPresent?.length > 0;
  const nonGigSelectedProduct = (parseFloat(product?.speedCode) === 939 || parseFloat(product?.speedCode) === 940);
  const gigsSelectdProduct =  (parseFloat(product?.speedCode) === 941 || parseFloat(product?.speedCode) === 947);
  let installationType = false;
  let professionalOneTimeCharge = false;

  let showFiosDerterminedAtCheckout = nonGigSelectedProduct;
  if(nonGigSelectedProduct || (gigsSelectdProduct && cust_optState==='SEAMLESS')){

    if(checkoutState.accordionStatus?.creditCheck!=="completed"){
      showFiosDerterminedAtCheckout = true; 
      fiosPresent = false;
      installationType = false;
    }
    else if(checkoutState.accordionStatus?.creditCheck==="completed" && (checkoutState.accordionStatus?.personalInfo==="completed" || checkoutState.accordionStatus?.personalInfo==="change" ))
    {
      showFiosDerterminedAtCheckout= false;
      installationType = true;
      
     if(checkoutState.selDueDateType !== '' && checkoutState?.eligibleInstallation==="TechOnly" && checkoutState?.selDueDateType==="TECHVISIT"){
        professionalOneTimeCharge = true;
        installationType = true;
        
      }
    }

  }
  else {
    professionalOneTimeCharge = false;
    installationType = true;
  }
  
   

  useEffect(() => {
    /**Modal template */
    let selectedServices = { isInternet: InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)? true: false, 
      isTv:  false, 
      isVoice: false, 
      isYouTubeTV: InHomeUtils.isNotNull(buildProductState.streamServ.selectedProduct) ? true : false,
      isDataGig: false,
      isData75M: false,
      isDataNotGig: false,
      isData2G:false};
      
      if (InHomeUtils.isNotNull(buildProductState.internet.selectedProduct)) {             
         
        if(InHomeUtils.isNotEmpty(buildProductState.internet.selectedProduct.downSpeed)) {
            let selectedInternetProd = buildProductState.internet.selectedProduct;
            if(selectedInternetProd.downSpeed === '1024M')
                selectedServices.isDataGig = true;
            if (selectedInternetProd.downSpeed === '2048M') {
                selectedServices.isData2G = true;
            }
            if (selectedInternetProd.downSpeed === '2056M') {
                selectedServices.isData2G = true;
            }
            if(selectedInternetProd.downSpeed !== '1024M') {
                if(selectedInternetProd.downSpeed === '75M') 
                    selectedServices.isData75M = true;
                else
                    selectedServices.isDataNotGig = true;
            }
        }
      }
      if (InHomeUtils.isNotNull(buildProductState.tv.selectedProduct)) {
          selectedServices.isTv = true;
      }
      if (InHomeUtils.isNotNull(buildProductState.voice.selectedProduct)) {
          selectedServices.isVoice = true;
      }
      if (InHomeUtils.isNotNull(buildProductState.streamServ.selectedProduct)) {
          selectedServices.isSlingTV = true;
      }            
      if(InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(buildProductState.internet.selectedProduct.name) && buildProductState.internet.selectedProduct.name.indexOf('500') > -1 && maxSpeedCode === '940'){
          selectedServices.isDataMaxSpeed=true;
      }

      setpromoContentLayout(<div>
        { <TitleLockup
        data={{
        eyebrow: {
        size: 'titleXLarge',
        children: '',
        },
        title: {
        bold: false,
        size: 'titleLarge',
        children: 'Offer, pricing and service details',
        primitive: "h2"
        },
        }}
        /> }
        <ModalBody>
            <div className="fixer promoHeight"></div>
            <div className="hrline"></div>
            <div className="fixer promoHeight"></div>
            <span id="lblDisclaimer">
            <PromoDisclaimer 
              selectedServices={selectedServices}
              cart={cartState} 
              buildProductState={buildProductState}
              internetProductContent={buildProductState.internet}
              buildProductContent={buildProductState.disclaimerContentFragments}  
              productsDisclaimer={buildProductState.disclaimerProductsFragments} 
              YouTubeEligible = {InHomeUtils.isNotNull(buildProductState.tv) && 
                        InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && 
                        buildProductState.tv.selectedProduct.prodType === "OTTBASIC" &&
                        (buildProductState.tv.selectedProduct.prodTypeValue === "YOUTUBE" ||
                        buildProductState.tv.selectedProduct.prodTypeVal === "YOUTUBE") ? true : false }
              SlingEligible = {InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.streamServ) &&
                                InHomeUtils.isNotNull(buildProductState.streamServ.selectedProduct) && 
                                buildProductState.streamServ.selectedProduct.prodType === "OTTBASIC" &&
                            (buildProductState.streamServ.selectedProduct.prodTypeValue === "SLING_REFERAL" ||
                                buildProductState.streamServ.selectedProduct.prodTypeVal === "SLING_REFERAL") ? true : false } 
                    hoaFlow = {checkIsHoaFlow()}
                    vintageOfferQualified= {(buildProductState.offersEligible.indexOf(OfferTypes.vintageOffer) !== -1 )? true : false}                   
                    commonDisclaimer={buildProductState.disclaimerCommonFragments}
                    MFRTEligible = {''}
                    SOCNOCQual= {(lqState && lqState.lqResponse && lqState.lqResponse.occupancyType) !== undefined  ?  true : false}
                    loopQual= {lqState} 
                    maxSpeedCode = {maxSpeedCode}
                    />
            </span>
        </ModalBody>
    </div>);

    /**8end of template */

  }, []);
  
  if (
    isCartDataEmpty &&
    cartState.cartData[splitBillTab].oneTimeCharge !== undefined &&
    cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge !== undefined &&
    cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge !== null &&
    cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.length > 0
  ) {
    let setup = cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.filter((p) => p.prodType === 'SETUP');
    if (setup !== null && setup.length > 0 && setup[0].price !== null) {
      if (setup[0].price === 'Fee Waived') {
        isSetupFeeWaived = true;
        if (setupcharge !== 'FeeWaived') {
          //this.isFiosSetup('FeeWaived');
        }
      } else {
        if (setupcharge !== ''){
          //this.isFiosSetup('');

        } 
      }
    }
  }
  const isMax500plan = buildProductState?.internet?.m2mPlans?.findIndex(item => ["R3582","R3583"].includes(item?.id))> -1 ? false : true;
    if(isCartDataEmpty){
      cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
        if (serviceheaditems?.prodName?.includes("Gig") || buildProductState?.internet?.isFeeWaivedForAll || buildProductState?.internet?.isInstallFeeWaivedAllPrd || (isMax500plan && serviceheaditems?.prodName?.includes('500'))) {

          
          if(serviceheaditems?.prodName?.includes("Gig") || buildProductState?.internet?.isInstallFeeWaivedAllPrd)
          {
            isSetupFeeWaived =true;
          }
          if(isMax500plan && serviceheaditems?.prodName?.includes('500'))
          {
            if(checkoutState.accordionStatus?.creditCheck!=="completed"){
              isSetupFeeWaived = false;
            }
            else if(checkoutState.accordionStatus?.creditCheck==="completed" && checkoutState?.eligibleInstallation==="TechOnly" && checkoutState?.selDueDateType==="TECHVISIT")
            {
              isSetupFeeWaived = false;
            }else if(checkoutState.accordionStatus?.creditCheck==="completed" && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL')){
              isSetupFeeWaived = false;
            }       
            
          }
          
          if(serviceheaditems?.prodName?.includes("Gig") && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL') && checkoutState.accordionStatus?.creditCheck==="completed"){
            isSetupFeeWaived =false;
          }
          if(buildProductState?.internet?.isFeeWaivedForAll){
            isSetupFeeWaived =true;
          }
        }
      });
    }
  
  const getDueMonthlyPrice = () => {
    return isClassicalFlow ? `${cartState.cartHeader[splitBillTab].monthlyRcPrice}/mo` :`${cartState.cartHeader[splitBillTab].monthlyRcPrice}/mo`;
    
  }

  const getMonthlyTotalPrice = () => {
    // return isClassicalFlow ? `${cartState.cartHeader[splitBillTab].totalPrice}/mo` :`${cartState.cartHeader[splitBillTab].totalPrice}/mo`;
    let dueMonthlyPri = cartState.cartHeader[splitBillTab].monthlyRcPrice;
    dueMonthlyPri = dueMonthlyPri.replace('$','');
    let monthlySavingsPrice = getMonthlySavingsPrice();
    if(monthlySavingsPrice){
      monthlySavingsPrice = monthlySavingsPrice ? monthlySavingsPrice : 0;

      monthlySavingsPrice = monthlySavingsPrice?.toString()?.replace('$','');
      monthlySavingsPrice = monthlySavingsPrice?.toString()?.replace('/mo','');
      if(dueMonthlyPri=== monthlySavingsPrice){
        return '';
      }
      else{
        return '$'+(parseFloat(dueMonthlyPri)+parseFloat(monthlySavingsPrice))?.toFixed(2)+'/mo';
      }

    }
    else{
      return '';
    }
    


  }

  const getOneTimePrice = () => {   
    const setupfeeWaived = false;
    if (cartState.cartHeader !== null && cartState.cartHeader !== undefined && cartState.cartHeader.length > 0) {
      if (cartState.cartData !== null && cartState.cartData.length > 0 && cartState.cartData[splitBillTab].oneTimeCharge !== undefined && cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge !== undefined) {
        cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.map((obj) => {
              if (obj.price !== null && obj.price !== undefined && obj.price !== "Included" && obj.price !== "Fee Waived" && obj.bundleActucalPrice !== null && obj.bundleActucalPrice !== undefined) {
                  if(!installationType && obj.prodType === 'SETUP'){                    
                    return null;
                  }
                  isOnetimefee = true; 
                  if ((obj.maxInstallments !== null && obj.maxInstallments !== undefined)) {
                      if (obj.maxInstallments === 1) {
                          let price = obj.price;
                          price = price.substring(1, price.length);
                          OneTimePrice = parseFloat(OneTimePrice) + parseFloat(price);
                      }
                      else {
                          //multiplying quant in otc for buy fne
                          if(obj.prodName.toLowerCase().includes("buy") && !obj.prodName.toLowerCase().includes("installment")){
                                let price = obj.price;
                                price = price.substring(1, price.length);
                                if (obj.quantity > 1) {
                                  OneTimePrice= parseFloat(OneTimePrice) + (price * obj.quantity);
                                }else{
                                  OneTimePrice = parseFloat(OneTimePrice) + parseFloat(price);
                                }
                          }else{
                              OneTimePrice = parseFloat(OneTimePrice) + parseFloat(obj.bundleActucalPrice);
                          }
                      }
                  }
              }
              
          });
      }
    }

    if(professionalOneTimeCharge && (checkoutState.accordionStatus.creditCheck === 'completed' && checkoutState.accordionStatus.installation === 'required')){
      OneTimePrice = parseFloat(OneTimePrice);
      if(OneTimePrice){
        isOnetimefee = true; 
      }
      
    }

    //OneTimePrice = "$" + parseFloat(OneTimePrice).toFixed(2);   
    return OneTimePrice > 0 ? `$${parseFloat(OneTimePrice).toFixed(2)}`:'';
  }

  const oneTimeChargeList = () => {

    if (
      isCartDataEmpty &&
      cartState.cartData[splitBillTab].oneTimeCharge !== undefined &&
      cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge !== undefined &&
      cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge !== null &&
      cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.length > 0
    ) 
    {      
      onetimecharge = cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.map((onetimefee, index) => { 
        const isBuyRouterInstall = onetimefee?.prodType ==='ROUTERNRCBILLER' &&  onetimefee?.prodTypeVal === 'FTTP_ROUTER_CHR_WIRELESS_CONSUMER' && onetimefee?.prodName?.includes("Installment")
        let oneTimeProdName = onetimefee.prodName;
        let oneTimePrice = onetimefee.price;
        if(onetimefee.prodType === 'SETUP' && professionalOneTimeCharge && !buildProductState?.internet?.isFeeWaivedForAll){
          oneTimeProdName = 'Professional installation';
          oneTimePrice = '$99.00';
        }
        if(isBuyRouterInstall){
          oneTimeProdName =  onetimefee?.accordionTitle;
          oneTimePrice = `$${onetimefee?.bundleActucalPrice}`;
        }
        if (onetimefee.prodType === 'SETUP' && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL')) {
          isOnetimefee = false;
          return ""
        }
        
        return <li key={index} className={(onetimefee.prodType === "SPORTSPASS" && onetimefee.prodTypeVal === "ANNUALRENEWAL") || (onetimefee.prodType === 'SETUP' && !installationType && !fiosPresent) ? "hide " : ""} >
        <p className={"margin-bottom-zero cartSubhead"} style={{ color: '#000000' }}>
            <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">{oneTimeProdName}
            {InHomeUtils.isNotNull(onetimefee.quantity) && onetimefee.quantity > 1 ? '(' + onetimefee.quantity + ')' : ''}              </span>
            <span className={"reskin-right-text text-right right tiny-p-30 medium-p-25" }>
            {InHomeUtils.isNotNull(onetimefee.quantity) && onetimefee.quantity > 1 && onetimefee.price != 'Included'
                ? '$' + parseFloat(onetimefee.quantity * onetimefee.price.replace('$', '')).toFixed(2)
                : oneTimePrice}
            </span>
        </p>
        {isBuyRouterInstall && onetimefee?.description && <><div className="margin-top-micro">
              <div className="setupwaived tiny-p-60 medium-p-65">
                <Body size="small" color="#6F7171">
                  {onetimefee?.description?.replace("(","")?.replace(")","")}</Body>
               </div>
              <div className="text-right right tiny-p-40 medium-p-35 setupwaived">
                <Body size="small" color="#6F7171">
                 {onetimefee?.price} for 3 months
                </Body>
              </div>
            </div>
            </>}               
    </li>
    });
    }
   
    let fiosSetupDetermined ='';
    if(showFiosDerterminedAtCheckout && !buildProductState?.internet?.isFeeWaivedForAll){
      isOnetimefee = true;   
      fiosSetupDetermined = <li id="Month125451328" >
          <div> 
          <div className="setupwaived tiny-p-70 medium-p-75">
          <Body size="small" color="#000000">
            Fios Setup</Body>
            <Micro color="#6F7171">Additional charges may be applied based on your installation type.</Micro>
          </div>
          <div className="text-right right tiny-p-30 medium-p-25 setupwaived">
            <Body size="small" color="#000000">
              Determined at checkout
            </Body>
          </div>
          </div>
      </li>
    }
    
    return <>{onetimecharge}{professionalCharge}{fiosSetupDetermined}</>;

  }  

  const getOneTimeSavingPrice = () => {
    return "$99.00";
  }
 
  const oneTimeSavingList = () => { 
    return <li  style={{padding:"10px 0px 5px 3px"}} price="Included" subcategory="CHRG">
      
          <p className= "margin-bottom-zero cartSubhead"> 
          <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">
           {ReactHtmlParser(orderConstants.professionalInstallation)}
          </span>
          <span className="reskin-right-text text-right right tiny-p-30 medium-p-25" >$0.00 <br/>
          <span className={ "perksStrickoutPrice reskin-right-text text-right right" }><Micro size="small" viewport="mobile" color="#6F7171">$99.00</Micro></span></span>
          </p>

      </li> 
  } 

  const onCloseModal = () => {
    modalAction.closeModalWindow(modalWindowState.modalId, dispatch);
}

  const getMonthlySavingsPrice = () => {
    let totalDiscount = 0;

    {/**Perks Discount */}
    if (isCartDataEmpty && cartState.cartData[splitBillTab].perks !== undefined && cartState.cartData[splitBillTab].perks !== null && cartState.cartData[splitBillTab].perks.perks !== undefined
      && cartState.cartData[splitBillTab].perks.perks !== null && cartState.cartData[splitBillTab].perks.perks.length > 0) {
        totalDiscount = parseFloat(totalDiscount ? totalDiscount?.replace('-$', '') : 0);
        const perks = cartState.cartData[splitBillTab].perks.perks;
        perksInSavings = perks.map((perk, index) => {
          let perkActPrice;
          if(perk?.keyword) {
              const perkMrp = perk?.keyword?.split('MRP:')?.[1];
              perkActPrice = perkMrp?.split('|')?.[0];
          } else {
              perkActPrice = getPerkActualPrice(perk.prodId);
          }
          const perkSavings = (parseFloat(perkActPrice) - parseFloat(perk.price.replace('$',''))).toFixed(2);
          const perkSavingsPrice = (parseFloat(perkActPrice) - parseFloat(perk.bundleActucalPrice)).toFixed(2);
          totalDiscount = parseFloat(totalDiscount) + parseFloat(perkSavingsPrice);
          const perkName = (buildProductState?.isDisneyPromoPresent && perk?.prodId == 'R3558') ? 'Disney Bundle Perk Savings' : (buildProductState?.isNetmaxPromoEligible && perk?.prodId == 'R3559') ? 'Netflix & Max (With Ads) Perk Savings' : (cartState?.cartData?.[0]?.Promotions?.promotions?.filter((p) => p?.offerAttrValue === 'YOUTUBEPREMIUM_PERK_DISCOUNT') && perk?.prodId == 'R3680' ? perk?.prodName + 'Perk Savings' : perk?.prodName);
          return <li key={index} id={perk.prodId} style={{margin:"16px 0px 16px 0px"}}>
                    <p className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 16px 0px"}}>
                        <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">{perkName}</span>
                        <span className={ "reskin-right-text text-right right tiny-p-30 medium-p-25"  }>
                           {'$' + perkSavingsPrice + '/mo'}
                        </span>
                    </p>               
                </li>
        });
    }{/**Perks Discount End */}

    {/**Promotions discount */}
    if (
      isCartDataEmpty &&
      cartState.cartData[splitBillTab]?.Promotions &&
      InHomeUtils.isNotNull(cartState.cartData[splitBillTab]?.Promotions.promotions) &&
      cartState.cartData[splitBillTab]?.Promotions?.promoSectionTotalPrice
    ) {
       secTotalPrice =cartState.cartData[splitBillTab].Promotions.promoSectionTotalPrice.replace("$-","");
       secTotalPrice =secTotalPrice.replace("$","");
       if (secTotalPrice !== undefined) {
        secTotalPrice = Math.floor(secTotalPrice);
       }
       totalDiscount= '$' + (totalDiscount ? parseFloat(totalDiscount) + parseFloat(secTotalPrice) : parseFloat(( secTotalPrice))).toFixed(2) + '/mo';
    }

    return totalDiscount;
    
  }

  const getMonthlySavingsList = () => {

    let apbTxtMidnight = [];
    let abxTxtPrice = 0;
    {/**special Offer */}

    const netmaxOffer = cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers?.find((reward) => reward?.offerAttrValue === 'NETMAX_PERK_DISCOUNT');
    
    const mnhoffer = cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers?.find((reward) => reward?.offerAttrValue === 'MF4DISCF15');

    specialOffer = cartState.cartData[splitBillTab]?.Promotions?.promotions?.map((promo, index) => {
      if (typeof promo?.promoText === "string" && promo.promoText.includes("Internet Price Guarantee")) {
        return null
      }
      if (promo?.offerAttrValue === 'MF4MRKF15') {   // to supress ember marker in cart
        return null
      }
      if ((promo?.offerAttrValue==="FCP_AUTOPAY_DISCOUNT" || promo?.offerAttrValue?.includes?.("$10_AutoPay") || promo?.offerAttrValue?.includes?.("$5_AutoPay")) && !promo?.offerAttrValue?.toUpperCase?.()?.includes?.("DECLINE")) {
        isSplOfferAvailable = true;
        let promoTxt = promo.promoText;
        abxTxtPrice =  parseFloat(promo.price) + abxTxtPrice;
        if(apbTxtMidnight.length > 0)
        {
          
          apbTxtMidnight = [];
          promoTxt = "Auto Pay and paper free Discount (Internet & TV)";
        }
        else{
          if(promo?.offerFor === 'DATA'){
            promoTxt = "Auto Pay and paper free Discount (Internet)";
          }
          else if(promo?.offerFor === 'VIDEO'){
            promoTxt = "Auto Pay and paper free Discount (TV)"
          }
        }

        apbTxtMidnight.push(<>
          <li key={index} style={{margin:"10px 0px 5px 0px"}}>
              <p className={"margin-bottom-zero cartSubhead"} style={{ color: '#000000' }}>
                  <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">{promoTxt}</span>
                  <span className={"reskin-right-text text-right right tiny-p-30 medium-p-25" }>
                  {'$' + parseFloat(abxTxtPrice).toFixed(2) + "/mo"}
                  </span>
              </p>               
          </li>
        </>);
        if(apbTxtMidnight.length > 0) {
          apbTxtMidnight.push(<p className="margin-bottom-zero reskin-autopay-sec medium-p-70 tiny-p-70" > 
            <span id="AutopayMsg" style={{ fontSize: window.screen.width > 500 ? '12px': "11px", color: '#6F7171'}}>
              {checkoutState?.debitAutopay
                ? "To receive a monthly Auto Pay and Paper Free Billing discount, you must enroll in Paper Free Billing and set up Auto Pay with the Verizon Visa Card or Bank Account."
                : "Discount requires enrollment in paper-free billing and Autopay with Debit, ACH or Verizon Visa Card required."
              }
            </span>
          <span className="text-right right"></span>
          </p>);
        }
      }
      else if(promo?.offerAttrValue === "FCP_AUTOPAY_DECLINE" &&  cust_optState !== "SEAMLESS"){
        return null
      }
      else if(promo?.offerAttrValue !== 'MnM4_48M' && promo.offerAttrValue !== 'MF3MRKF15' && promo?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_TRACKER' && promo?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_MARKER' && promo?.offerAttrValue !== 'NETMAX_PERK_MARKER' && !["R3668", "R3669"]?.includes(promo?.promoId)){

        const promoDisplayTxt = promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT' ? 'Disney Bundle Special Gift Savings' : (promo?.offerAttrValue === 'NETMAX_PERK_DISCOUNT') ? 'Netflix & Max (With Ads) Special Gift Savings' : promo?.promoText;

        return(<li style={{margin:"16px 0px 16px 0px"}} className= {(promo.offerAttrValue && promo?.offerAttrValue==="FCP_AUTOPAY_DISCOUNT") ? "hide" : ""} key={index}>
            <p className={"margin-bottom-zero cartSubhead"}> 
            {/* <div className="discountWrapper"> */}
               <span className="setupwaived tiny-p-55 medium-p-65 orderSumSavings">{ InHomeUtils.vzFwdOfferIds?.includes(promo?.promoId) ? InHomeUtils.getVzfwdOfferName(promo?.promoId): promoDisplayTxt}</span>
                <span className={ "reskin-right-text text-right right tiny-p-45 medium-p-35" }>
                    <span className={(promo.price==='0.00')?'hide':''}>
                   {(InHomeUtils.isNotNull(promo.price) && InHomeUtils.isNotEmpty(promo.price)) ? (promo?.promoId==="R3484" || promo?.promoId==='R4437' || promo?.promoId==='R4136') ? "Up to $30.00/mo" : promo?.promoId === "R4071" ? "Up to $40.00/mo": promo?.promoId==='R4072' ? "Up to $45.00/mo" : promo.price.indexOf('.') === -1 ? '$'+promo.price +'.00/mo' :'$'+promo.price + "/mo" : ''}
                   </span>
                   {
              promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT'
              ? <>
                  <span className='text-right right tiny-p-100 medium-p-100 cart_perk_offer'>
                      <Micro size="small" viewport="mobile" color="#6F7171"> For 12 months</Micro>
                  </span>
              </>
                  : promo?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT"
                    ? <span className='text-right right tiny-p-100 medium-p-100 cart_perk_offer'>
                      <Micro size="small" viewport="mobile" color="#6F7171">for 6 months</Micro>
                    </span>
              : <></>
              }  
                </span>
            </p> 
                       
        </li>)
        }
    });

    /* For netmax, promo comes in Promotions -> special offers but UI uses only Promotions -> offers to display savings. So adding manual logic to integrate netmax alone in savings section.
    */
    if(netmaxOffer) {
      const netmaxPromoDts = <li style={{margin:"16px 0px 16px 0px"}}>
          <p className={"margin-bottom-zero cartSubhead"}>
          <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">Netflix & Max (With Ads) Special Gift Savings</span>
            <span className={ "reskin-right-text text-right right tiny-p-30 medium-p-25" }>
                <span>
              {'$'+ netmaxOffer?.price + "/mo"}
              </span>
              {
                netmaxOffer?.offerAttrValue === 'NETMAX_PERK_DISCOUNT'
                ? <>
                    <span className='text-right right tiny-p-100 medium-p-100 cart_perk_offer'>
                        <Micro size="small" viewport="mobile" color="#6F7171"> For 12 months</Micro>
                    </span>
                </>
                : <></>
              }  
            </span>
          </p>     
      </li>
      specialOffer?.push(netmaxPromoDts);
    }

    if(mnhoffer) {
      const mnhOfferText = "Mobile + Home Discount(Internet)"; 
      const mnhofferEligible = <li style={{margin:"16px 0px 16px 0px"}}>
          <p className={"margin-bottom-zero cartSubhead"}>
          <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">{mnhOfferText}</span>
            <span className={ "reskin-right-text text-right right tiny-p-30 medium-p-25" }>
                <span>
                {mnhoffer?.price && mnhoffer?.price != "0.00" ? '$' + mnhoffer?.price + "/mo" : ''}
              </span>
               
            </span>
          </p>     
      </li>
      specialOffer?.push(mnhofferEligible);
    }

    {/**end of special offer */}

    if(isCartDataEmpty){

      if (InHomeUtils.isNotNull(cartState.cartData[splitBillTab].streamService) && InHomeUtils.isNotNull(cartState.cartData[splitBillTab].streamService.streamServiceProds)
        && cartState.cartData[splitBillTab].streamService.streamServiceProds.length > 0) {
            for(let stremprod=0; stremprod < cartState.cartData[splitBillTab].streamService.streamServiceProds.length ; stremprod++)
            {
                if(cartState.cartData[splitBillTab].streamService.streamServiceProds[stremprod].prodTypeVal === "SLING_REFERAL"){
                    isSlingTV = true;
                } 
                else if(cartState.cartData[splitBillTab].streamService.streamServiceProds[stremprod].prodTypeVal === "YOUTUBE")
                {
                    isYoutube = true;
                }
            }
      }


      if(isSlingTV){
        if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments["SlingTVInCart"])){
            disclaimerStreamingSling = buildProductState.disclaimerContentFragments["SlingTVInCart"];
            if (InHomeUtils.isNotNull(disclaimerStreamingSling) && InHomeUtils.isNotEmpty(disclaimerStreamingSling.promo)  && disclaimerStreamingSling.promo !== "<p>N/A</p>"){
                if(InHomeUtils.isNotEmpty(disclaimerStreamingSling.location)){
                    if(disclaimerStreamingSling.location === LocationIds.streamingCartAbove){
                        isSlingTVAbove = true;
                    }else if(disclaimerStreamingSling.location === LocationIds.streamingCartBelow){
                        isSlingTVBelow = true;
                    }
                }
            }
        }
      }

      
      {/***DisclaimerStreaming */}
      if (InHomeUtils.isNotNull(cartState.cartData[splitBillTab].youtubePrd) && InHomeUtils.isNotNull(cartState.cartData[splitBillTab].youtubePrd.youtubePrd)
        && cartState.cartData[splitBillTab].youtubePrd.youtubePrd.length > 0) {
        isYoutube = true;
      }
      else if (InHomeUtils.isNotNull(cartState.cartData[splitBillTab].streamService) && InHomeUtils.isNotNull(cartState.cartData[splitBillTab].streamService.streamServiceProds)
          && cartState.cartData[splitBillTab].streamService.streamServiceProds.length > 0) {
              if(cartState.cartData[splitBillTab].streamService.streamServiceProds[0].prodTypeVal === "YOUTUBE" ){
                  isYoutube = true;
              }
      }
      if(isYoutube){
          if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments["StreamingServicesCart"])){
              disclaimerStreaming = buildProductState.disclaimerContentFragments["StreamingServicesCart"];
              if (InHomeUtils.isNotNull(disclaimerStreaming) && InHomeUtils.isNotEmpty(disclaimerStreaming.promo)  && disclaimerStreaming.promo !== "<p>N/A</p>"){
                  if(InHomeUtils.isNotEmpty(disclaimerStreaming.location)){
                      if(disclaimerStreaming.location === LocationIds.streamingCartAbove){
                          isYoutubeAbove = true;
                      }else if(disclaimerStreaming.location === LocationIds.streamingCartBelow){
                          isYoutubeBelow = true;
                      }
                  }
              }
          }
      }
      {/***DisclaimerStreaming code end*/}
      {/***DisclaimerStreaming Tech code */}
      
      if(InHomeUtils.isNotNull(buildProductState?.techsurecloud) && InHomeUtils.isNotNull(buildProductState?.techsurecloud?.selectedProduct) && InHomeUtils.isNotNull(buildProductState?.techsurecloud?.selectedProduct) && buildProductState?.techsurecloud?.selectedProduct?.accordionTitle === "Verizon Cloud Unlimited"){
        isTechSure = true;
    }

        if(isTechSure){
          if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments) && InHomeUtils.isNotNull(buildProductState.disclaimerContentFragments["~TechSureCloudInCart"])){
              disclaimerTechSure = buildProductState.disclaimerContentFragments["~TechSureCloudInCart"];
              if (InHomeUtils.isNotNull(disclaimerTechSure) && InHomeUtils.isNotEmpty(disclaimerTechSure.promo)  && disclaimerTechSure.promo !== "<p>N/A</p>"){
                  if(InHomeUtils.isNotEmpty(disclaimerTechSure.location)){
                      if(disclaimerTechSure.location === LocationIds.streamingCartAbove){
                          isTechSureAbove = true;
                      }else if(disclaimerTechSure.location === LocationIds.streamingCartBelow){
                          isTechSureBelow = true;
                      }
                  }
              }
          }
      }

    }
    return <>
        <div className={`margin-left-micro margin-top-tiny setupWavedMobile ${apbTxtMidnight ? '' : 'hide'}`}>
          <Body size="small" className="bold padding-left" viewport={InHomeUtils.getdeviceType()} color="black">
            {apbTxtMidnight}
            {specialOffer}
            <PromoCartText locationId={LocationIds.streamingCartBelow} disclaimerFragment={disclaimerStreaming} />
            <PromoCartText locationId={LocationIds.streamingCartAbove} disclaimerFragment={disclaimerTechSure} />
            <PromoCartText locationId={LocationIds.streamingCartBelow} disclaimerFragment={disclaimerStreamingSling} />
            {perksInSavings}

          </Body>
        </div>    
    </>
  }

  const PromoCartText = (props) => {
    let template;
      if (InHomeUtils.isNotNull(props.disclaimerFragment) && InHomeUtils.isNotEmpty(props.disclaimerFragment.promo)  && props.disclaimerFragment.promo !== "<p>N/A</p>"){    
          if(InHomeUtils.isNotEmpty(props.disclaimerFragment.location) && props.disclaimerFragment.location.substring(0,3) === props.locationId) {
              template = <li className=""></li>;
              template = <p className="margin-bottom-zero"> {ReactHtmlParser(props.disclaimerFragment.promo)}</p>
          }
      }
      return (
          <React.Fragment>
            {template}
          </React.Fragment>
      )
  } 

  const getDisplayPrice =(price, isMonthly) => {
    let priceStr = "";
    if (typeof price === "number") {
        priceStr = price.toString();
    } else if (typeof price === "string") {
        priceStr = price.replace(/^(\$)/, "").replace(/\,/g, "").replace(/(\/mo)$/, "");
    }
    const numberFormat = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(priceStr);
    if (numberFormat !== "$NaN") {
        if (numberFormat === "$0.00") {
            return "";
        }
        return numberFormat + (isMonthly ? "/mo" : "");
    } else {
        return price;
    }
}
  
  const getMonthlyChargePrice = () => {
    
    let monthlyChargePrice = 0;

    if (cartState.cartHeader !== null && cartState.cartHeader !== undefined && cartState.cartHeader.length > 0) {
      if (cartState.cartData !== null && cartState.cartData.length > 0 && cartState.cartData[splitBillTab].internet !== null && cartState.cartData[splitBillTab].internet.internetProds !== undefined && cartState.cartData[splitBillTab].internet.internetProds !== null && cartState.cartData[splitBillTab].internet.internetProds.length > 0) {

        cartState.cartData[splitBillTab].internet.internetProds.map((obj) => {
              if (obj.price !== null && obj.price !== undefined && obj.price !== "Included" && obj.price !== "Fee Waived" && obj.bundleActucalPrice !== null && obj.bundleActucalPrice !== undefined) {
                  
                  isMonthlyCharge = true; 
                  if ((obj.maxInstallments !== null && obj.maxInstallments !== undefined)) {
                      if (obj.maxInstallments === 1) {
                          let price = obj.price;
                          price = price.substring(1, price.length);
                          monthlyChargePrice = parseFloat(monthlyChargePrice) + parseFloat(price);                        
                            
                      }
                      else {
                          
                        monthlyChargePrice = parseFloat(monthlyChargePrice) + parseFloat(obj.bundleActucalPrice);
                          
                      }
                  }
              }
          });
      }
    }

    return monthlyChargePrice > 0 ? `$${parseFloat(monthlyChargePrice).toFixed(2)}`:'';
  }

  const monthlyChargeList = () => {

    if (cartState.cartData !== null && cartState.cartData.length > 0 && cartState.cartData[splitBillTab].internet !== null && cartState.cartData[splitBillTab].internet.internetProds !== undefined && cartState.cartData[splitBillTab].internet.internetProds !== null && cartState.cartData[splitBillTab].internet.internetProds.length > 0) {         
      monthlyCharge = cartState.cartData[splitBillTab].internet.internetProds.map((internet, index) => { 
        return <li key={index}  >
        <p className={"margin-bottom-zero cartSubhead"} style={{ color: '#000000' }}>
            <span className="setupwaived tiny-p-70 medium-p-75 orderSumSavings">{internet.prodName}</span>
            <span className={"reskin-right-text text-right right tiny-p-30 medium-p-25" }>
            {internet.price}
            </span>
        </p>               
    </li>
    });
    }

    return <>{monthlyCharge}</>;

  }

  const handleKeyDown = (e,action) => {
    if (e?.keyCode === 13 || e?.keyCode === 32) {
        onOpenModal(e);
        e.preventDefault();
    }
  }
  const handleTabKeyDown= (e, index) => {
      if (e.keyCode === 13 || e.keyCode === 32) {
          onCartSplitBillClick(index);
      }
  }

  const checkIsHoaFlow = () =>{
    return lqState &&  lqState.hoaFlowDetails && lqState.hoaFlowDetails.isHoaFlow;;
  } 

  const offerpriceModalClose = (e) => {
    modalAction.closeModalWindow(modalWindowState.modalId, dispatch);
  };  

  const onCartSplitBillClick = (action) => {
    cartActions.splitBillTab(action, dispatch)
  } 

  const onOpenModal = (e) => {
    if(e.target.id){
      modalAction.openModalWindow(e.target.id, dispatch);
      if (e.target.id === "SOC") {
          buildfiosaction.fetchPostSoc(dispatch, visitId, true, "NC");
          updateSCTags('monthly bill estimate + taxes and fees');
          tempVzdlSCData.detail = "Estimated monthly charges";
          tempVzdlSCData.events = "prodView";
          tempVzdlSCData.name =  "order confirmation";
          updateVzdlSCCustomEvent("flowCompleted", "pageViewOmni", "detail,events,name");
      }
      if (e.target.id === "PROMO") {            
          updateSCTags("Offer, pricing and services details");
          tempVzdlSCData.events = "prodView";
          tempVzdlSCData.detail = "Offer, pricing and services details";
          updateVzdlSCCustomEvent(appState?.flowType === 'MV' ? "movesInterOrderSum" : "interOrderSum", "pageViewOmni", "events,detail");
      } 
    }
         
  }

  const onOffersToggleClick = (action) => {
    cartActions.offersToggle(action, dispatch,visitId)  
    if(cartState.cartOfferToggle){
        if(action === 'AutoPayToggle'){
            if (!cartState.cartOfferToggle.isAutopayOffer) {
                updateSCTags("cart-close-price with ap and pfb");
            }
            else if (cartState.cartOfferToggle.isAutopayOffer) {
                updateSCTags("cart-expand-price with ap and pfb");
            }
        }
        else if(action === 'SpecialOfferToggle'){
            if (!cartState.cartOfferToggle.isSpecialOffer) {
                updateSCTags("total monthly savings - collapse" );
            }
            else if (cartState.cartOfferToggle.isSpecialOffer) {
                updateSCTags("total monthly savings - expand");
            }
        }
        else if(action === 'SpecialOfferOneTimeToggles'){
            if (!cartState.cartOfferToggle.isSpecialOneTimeOffer) {
                updateSCTags("one time savings - collapse");
            }
            else if (cartState.cartOfferToggle.isSpecialOneTimeOffer) {
                updateSCTags("one time savings - expand");
            }
        }
    }
  }

  const toggleOneTimeCharges = () => {
    //updateDetailValue("order summary")
    setTimeout(() => { updateSCTags(cartState.showOneTimeCharges ? "one-time charges - expand" : "one-time charges - minimize")}, 1000)
    cartActions.toggleOneTimeCharges(dispatch,cartState.showOneTimeCharges);
  };

  const toggleMonthlyCharges = () => {
    //updateDetailValue("order summary")
    setTimeout(() => { updateSCTags(cartState.showOneTimeCharges ? "monthly charges - expand" : "monthly charges - minimize")}, 1000)
    cartActions.toggleMonthlyCharges(dispatch,cartState.showMonthlyCharges);
  };

  
  
  return (
      <React.Fragment>
      <div data-drop-cart="">         

          <div className="cart-tabs columns margin-bottom-tiny active">                            
            <ContentRenderComp
              subscript="With savings"
              mainTitle="Due monthly"
              price={getDueMonthlyPrice()} 
              strikeOutPrice={getMonthlyTotalPrice()}
              //price={`${cartState.cartHeader[0].totalPrice}/mo` } 
              subText={orderConstants.DueMonthlyTxt}
              id="DUEMONTHLY"
              showContent={true}
              displayBold = {true}
            />
            <div className={`${window.screen.width>500 ?  'offerAndMonth': 'offerAndMonthMobile'} margin-left-micro `}>
                <div id='SocBlock' className="text-black medium-text-left tiny-text-left left socRskn" style={{ marginTop:"5px",marginBottom:'25px' ,display: 'block padding-top-tiny' }}>                                    
                <FirstBill FBESection="cart" isFCPflow={(lqState.isFCPflow || (lqState && lqState.hoaFlowDetails && lqState.hoaFlowDetails.isHoaFlow))} isCartOpen={cartState.isCartOpen}  />
                </div>
            </div> 

            {/* <ContentRenderComp 
              mainTitle="Monthly charges"
              price={getMonthlyChargePrice()}
              subText={''}
              toggleCaretIcon={cartState.showMonthlyCharges}
              onClick={(e) =>toggleMonthlyCharges()}
              onKeyPress={(e) => toggleMonthlyCharges()}
              onKeyDown={(e) => handleKeyDown(e, "SpecialOfferMonthlyCharges")}
              listItems = {monthlyChargeList()}
              showCaretIcon="true"
              id="MONTHLYCHARGE"
              horizontalLine = "true"
              showContent = {isMonthlyCharge}
            /> */}
          <ContentRenderComp 
              mainTitle="One-time charges"
              price={getOneTimePrice()}
              subText={orderConstants.OneTimeChargesTxt}
              toggleCaretIcon={cartState.showOneTimeCharges}
              onClick={(e) =>toggleOneTimeCharges()}
              onKeyPress={(e) => toggleOneTimeCharges()}
              onKeyDown={(e) => handleKeyDown(e, "SpecialOfferOneTimeCharges")}
              listItems = {oneTimeChargeList()}
              showCaretIcon="true"
              id="ONETIMECHARGE"
              horizontalLine = "true"
              showContent = {isOnetimefee === true ? !checkIsHoaFlow() ? true : false : false}
              displayBold = {true}
            />
           
                
            <ContentRenderComp 
              mainTitle="One-time savings"
              price={getOneTimeSavingPrice()}                    
              toggleCaretIcon={!cartState.cartOfferToggle.isSpecialOneTimeOffer}
              onClick={(e) =>onOffersToggleClick("SpecialOfferOneTimeToggles")}
              onKeyDown={(e) => handleKeyDown(e, "SpecialOfferOneTimeToggles")}
              listItems = {oneTimeSavingList()}
              showCaretIcon="true"
              horizontalLine = "true"
              id="ONETIMESAVINGS"
              priceColor="green"
              showContent = {isSetupFeeWaived === true ? !checkIsHoaFlow() ? true : false : false}
              displayBold = {true}
            />

            <ContentRenderComp 
              mainTitle="Monthly savings"
              price={getMonthlySavingsPrice()}                   
              toggleCaretIcon={!cartState.cartOfferToggle.isSpecialOffer}
              onClick={(e) =>onOffersToggleClick("SpecialOfferToggle")}
              onKeyDown={(e) => handleKeyDown(e, "SpecialOfferToggle")}
              listItems = {getMonthlySavingsList()}
              showCaretIcon="true"              
              horizontalLine = "true"
              id="MONTHLYSAVINGS"
              priceColor="green"
              showContent={true}
              displayBold = {true}
            />           
                      
          </div>           
                </div>
      </React.Fragment>
  );
  
}

const mapStateToProps = state => {
    return {
      lqState: state.loopQual,
      appState: state.app, 
      cartRedState: state.cart,  
      cartProfileState: state.profileCart, 
      checkoutState: state.checkout,
      modalWindowState: state.modalWindow,     
      buildProductState: state.buildProduct,     
      cust_optState: state.moveExp.cust_opt,
      moveExpState: state.moveExp.moveLandingExp,
      socState: state.firstbill,
      visitId: state.app.visitId,          
    }
  }
export default React.memo(connect(mapStateToProps)(OrderSummaryReskin));
